import { defineEvent } from '../types/event';
export var REBUY_UPSELL_CART_ADD = defineEvent({
    platforms: [
        {
            name: 'Optimizely',
            alias: 'add_to_cart_from_rebuy_upsell'
        }
    ]
});
